// import { LOCATION_CHANGED } from 'redux-little-router'
import { actionTypes } from '../constants'

const initialState = {
  isOpen: false,
}

const sort = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SORT_CONTROL_WAS_CLICKED:
      return {
        ...state,
        isOpen: !state.isOpen,
      }

    default:
      return state
  }
}

export default sort
